import { env } from '@/shared/config';

/**
 * Где запущено приложение: мини-апп в Telegram или обычная вкладка браузера
 * (веб-версия, см. WEB.md). Решается один раз на старте в `main.tsx` — по
 * тому, есть ли данные запуска Telegram, — и дальше не меняется.
 */
let telegram = true;

export function setTelegramPlatform(value: boolean): void {
  telegram = value;
}

export function isTelegram(): boolean {
  return telegram;
}

const DEV_TELEGRAM_KEY = 'dev:telegram';

/**
 * Только dev: обычная вкладка браузера — веб-версия, как в проде. Чтобы
 * посмотреть мини-апп без Telegram (с подменой окружения, `mock-env`),
 * `?tg=1` включает её до конца вкладки, `?tg=0` выключает. Настоящий запуск
 * из Telegram (через тоннель) узнаётся по данным запуска в адресе и тоже
 * запоминается до конца вкладки: роутер сразу убирает их из адреса, и
 * перезагрузка внутри Telegram без этого открылась бы как веб.
 */
export function isDevTelegramMock(): boolean {
  if (!env.isDev) return false;
  try {
    const flag = new URLSearchParams(window.location.search).get('tg');
    if (flag === '1' || window.location.hash.includes('tgWebAppData')) sessionStorage.setItem(DEV_TELEGRAM_KEY, '1');
    if (flag === '0') sessionStorage.removeItem(DEV_TELEGRAM_KEY);
    return sessionStorage.getItem(DEV_TELEGRAM_KEY) === '1';
  } catch {
    return false;
  }
}
